import { jwtDecode } from 'jwt-decode';
import moment from 'moment';

export interface ITokenMetadata {
  aud: string;
  email: string;
  email_verified: boolean;
  exp: number;
  iat: number;
  iss: string;
  name: string;
  nickname: string;
  picture: string;
  sub: string;
  updated_at: string;
}

const JWT_STORAGE_KEY = 'catapult::sso';

export function addIdTokenLocalStorage(token: string) {
  localStorage.setItem(JWT_STORAGE_KEY, token);
}

export function removeIdTokenLocalStorage() {
  localStorage.removeItem(JWT_STORAGE_KEY);
}

export function hasIdTokenLocalStorage() {
  return !!localStorage.getItem(JWT_STORAGE_KEY);
}

export function getIdTokenLocalStorage() {
  return localStorage.getItem(JWT_STORAGE_KEY);
}

export function decodeToken(token: string) {
  const decoded = jwtDecode<ITokenMetadata>(token);
  return decoded;
}

export function isJwtValid(token: string) {
  try {
    const decoded = jwtDecode<ITokenMetadata>(token);
    const currentDate = moment.unix(moment().unix());

    const expiryDate = moment.unix(decoded.exp || 0);
    return (
      moment(currentDate).isSameOrBefore(expiryDate)
    );
  } catch (error) {
    return false;
  }
}
